<template>
    <v-container>
        <v-row>
            <v-col align="center">Мы помоем вам определить свой путь в обширном мире программирования</v-col>
        </v-row>
        <v-row>
            <v-col>Дружная и опытная команда разработчиков ищет умы для общего прогресса</v-col>
        </v-row>
        <v-row>
            <v-col cols="2">Мы заинтересованы в :</v-col>
            <v-col>{{Kval}}</v-col>
        </v-row>
        <v-row>
            <v-col cols="2">Количество студентов уже написавих нам:</v-col>
            <v-col>{{Kolvo}}</v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    props:["Kval","Kolvo"]
}
</script>